import React, { memo, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import { CustomCheckBox } from '../Catalog/components/helper';
import useFetchData from 'app/hooks/useFetchData';
import { getCommonAmenitiesDataApi } from 'app/services/holidayApi';
import { renderReplaceText } from 'utils/helper';
interface IFilterOtherForFHTProps {
  onChange?: (data: { ratings: string[]; amenities: string[] }) => void;
}

const FilterOtherForFHT = (props: IFilterOtherForFHTProps) => {
  const { onChange } = props;
  const searchParams = new URLSearchParams(window.location.search);
  const defaultRatings = searchParams.get('ratings')?.split(',') || [];
  const defaultAmenities = searchParams.get('amenities')?.split(',') || [];
  const [amenities, setAmenities] = useState([]);
  const translations = useSelector(selectTranslations);
  const ratings = useMemo(
    () =>
      [5, 4, 3]
        .map(n => ({
          label: renderReplaceText(translations?.['b2b.txt.nStarHotel'], {
            n,
          }),
          value: String(n),
        }))
        .concat({
          label: renderReplaceText(
            translations?.['b2b.txt.nStarHotelOrBelow'],
            {
              n: 2,
            },
          ),
          value: 'LT_2',
        }),
    [translations],
  );
  const { onFetchData: onFetchAmenity } = useFetchData({
    actionApi: getCommonAmenitiesDataApi,
    IIFE: false,
    onSuccess: response => {
      const amenityTemp = response?.data?.map(el => ({
        value: el.code,
        label: el.name,
      }));
      setAmenities(amenityTemp);
    },
  });
  useEffect(() => {
    onFetchAmenity();
  }, []);
  const [showMore, setShowMore] = useState(false);
  const [selectedRatings, setSelectedRatings] =
    useState<string[]>(defaultRatings);
  const [selectedAmenities, setSelectedAmenities] =
    useState<string[]>(defaultAmenities);

  const handleRatingChange = (values: string[]) => {
    setSelectedRatings(values);

    onChange?.({
      ratings: values,
      amenities: selectedAmenities,
    });
  };

  const handleAmenitiesChange = (values: string[]) => {
    setSelectedAmenities(values);

    onChange?.({
      ratings: selectedRatings,
      amenities: values,
    });
  };
  const displayedAmenities = useMemo(() => {
    return showMore ? amenities : amenities.slice(0, 10);
  }, [showMore, amenities]);
  return (
    <Wrapper>
      <SectionTitle>{translations?.['b2b.txt.otherOptions']}</SectionTitle>
      <Card>
        <CardTitle>{translations?.['b2b.txt.rating']}</CardTitle>
        {CustomCheckBox(ratings, selectedRatings, handleRatingChange)}
      </Card>

      <Card>
        <CardTitle>{translations?.['b2b.txt.amenitiesAndServices']}</CardTitle>
        {CustomCheckBox(
          displayedAmenities,
          selectedAmenities,
          handleAmenitiesChange,
        )}
        {amenities.length > 10 && (
          <ShowMoreButton onClick={() => setShowMore(prev => !prev)}>
            {showMore
              ? `- ${translations?.['b2b.txt.collapse']}`
              : `+ ${translations?.['b2b.txt.expand']}`}
          </ShowMoreButton>
        )}
      </Card>
    </Wrapper>
  );
};
export default memo(FilterOtherForFHT);
const Wrapper = styled.div`
  padding: 14px;
`;
const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin-top: 12px;
  margin-bottom: 12px;
`;
const Card = styled.div`
  background: #f6f6f6;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 12px;
`;
const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #000000;
`;
const ShowMoreButton = styled.button`
  margin-top: 18px;
  border: none;
  background: transparent;
  color: #f06f24;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
`;
